import {useState} from "react";
import "./css/auth.css";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";

export const isValidEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
}

export default function AuthPage({ onAuth }) {
    const [mode, setMode] = useState("login");
    const [form, setForm] = useState({nickname: "" , email: "", password: "", confirm: "" });
    const [error, setError] = useState("");
    const [shake, setShake] = useState(false);
    const [sending, setSending] = useState(false);
    // const [verification, setVerification] = useState(false);

    // useEffect(() => {
    //     if (verification) {
    //         socket.emit('join-room', `user:${verification.email}`)
    //
    //         socket.on('success-verification', () =>
    //             axios.post(`/api/users/auth`, verification)
    //                 .then(() => onAuth())
    //                 .catch(err => console.log(err))
    //         )
    //     }
    //
    // }, [verification])

    function register(regUserData) {
        setSending(true);

        axios.post("/api/users/reg", regUserData)
            .then(() => onAuth()).catch(err => {
            if (err.response) {
                const status = err.response.status;

                if (status === 409) {
                    setError("Пользователь уже существует");
                    triggerShake();
                } else {
                    setError("Ошибка регистрации");
                    triggerShake()
                }
            } else if (err.request) {
                setError("Нет ответа от сервера");
                triggerShake();
            } else {
                setError("Ошибка отправки");
                triggerShake();
            }
        }).finally(() => setSending(false));
    }

    function authenticate(authUserData) {
        setSending(true);

        axios.post("/api/users/auth", authUserData)
            .then(() => onAuth())
            .catch(err => {
                if (err.response) {
                    setError("Неверный e-mail или пароль");
                    triggerShake()
                } else if (err.request) {
                    setError("Нет ответа от сервера");
                    triggerShake();
                } else {
                    setError("Ошибка отправки");
                    triggerShake();
                }
            }).finally(() => setSending(false));
    }

    const triggerShake = () => {
        setShake(true);
        setTimeout(() => setShake(false), 500);
    };

    const handleChange = (e) => {
        setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
        setError("");
    };

    const handleSubmit = () => {
        const {nickname, email, password, confirm } = form;

        if (!email.trim() || !password.trim() || (mode === "register" && !nickname.trim())) {
            setError("Заполните все поля");
            triggerShake();
            return;
        }

        // const users = getUsers();
        if (!isValidEmail(email)) {
            setError("Невалидный email");
            triggerShake();
            return;
        }

        if (mode === "register") {
            if (password !== confirm) {
                setError("Пароли не совпадают");
                triggerShake();
                return;
            }
            if (password.length < 6) {
                setError("Пароль — минимум 6 символов");
                triggerShake();
                return;
            }

            // users[email] = { password };
            // saveUsers(users);
            register({
                password: password.trim(),
                nickname: nickname.trim(),
                email: email.trim(),
            })
        } else {
            // const user = users[email];
            // if (!user || user.password !== password) {
            //     setError("Неверный логин или пароль");
            //     triggerShake();
            //     return;
            // }
            authenticate({
                password: password.trim(),
                email: email.trim(),
            })
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleSubmit();
    };

    const switchMode = (newMode) => {
        setMode(newMode);
        setForm({nickname: form.nickname , email: form.email, password: form.password, confirm: "" });
        setError("");
    };

    const [show, setShow] = useState(false);

    return (
        <div className="auth-overlay">
            <div className={`auth-card${shake ? " shake" : ""}`}>

                {/* Header */}
                <div className="auth-header">
                    <div className="auth-logo">Spotify Clone</div>
                    <h1 className="auth-title">
                        {mode === "login" ? "Добро пожаловать" : "Создать аккаунт"}
                    </h1>
                    <p className="auth-subtitle">
                        {mode === "login"
                            ? "Войдите, чтобы продолжить"
                            : "Заполните данные для регистрации"}
                    </p>
                </div>

                {/* Tabs */}
                <div className="auth-tabs">
                    <button
                        className={`auth-tab${mode === "login" ? " active" : ""}`}
                        onClick={() => switchMode("login")}
                    >
                        Вход
                    </button>
                    <button
                        className={`auth-tab${mode === "register" ? " active" : ""}`}
                        onClick={() => switchMode("register")}
                    >
                        Регистрация
                    </button>
                </div>

                {/* Fields */}
                <div className="auth-fields">
                    {mode === "register" && (
                        <div className="auth-field-group">
                            <label className="auth-label">Псевдоним</label>
                            <input
                                className="auth-input"
                                name="nickname"
                                type="text"
                                value={form.nickname}
                                onChange={handleChange}
                                onKeyDown={handleKeyDown}
                                placeholder="Введите псевдоним"
                                autoComplete="off"
                            />
                        </div>
                    )}

                    <div className="auth-field-group">
                        <label className="auth-label">E-mail</label>
                        <input
                            className="auth-input"
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            placeholder="Введите e-mail"
                            autoComplete="email"
                        />
                    </div>

                    <div className="auth-field-group">
                        <label className="auth-label">Пароль</label>
                        <input
                            className="auth-input"
                            name="password"
                            type={show ? 'text' : 'password'}
                            value={form.password}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            placeholder="Введите пароль"
                            autoComplete={mode === "login" ? "current-password" : "new-password"}
                            />
                        <button
                            type="button"
                            onClick={() => setShow(s => !s)}
                            aria-label={show ? "Скрыть пароль" : "Показать пароль"}
                            style={{
                                position: 'absolute', right: '8px', top: '50%',
                                transform: 'translateY(-10%)',
                                background: 'none', border: 'none', cursor: 'pointer',
                                color: '#d4d4d4'
                            }}
                        >
                            {show ? <EyeOff size={16} /> : <Eye size={16} />}
                        </button>
                    </div>

                    {mode === "register" && (
                        <div className="auth-field-group">
                            <label className="auth-label">Подтверждение пароля</label>
                            <input
                                className="auth-input"
                                name="confirm"
                                type="password"
                                value={form.confirm}
                                onChange={handleChange}
                                onKeyDown={handleKeyDown}
                                placeholder="Повторите пароль"
                                autoComplete="new-password"
                            />
                        </div>
                    )}

                    {error && <div className="auth-error">{error}</div>}

                    <button className="auth-button" onClick={handleSubmit} disabled={sending}>
                        {mode === "login" ? "Войти" : "Зарегистрироваться"}
                    </button>
                </div>

                {/* Footer */}
                <p className="auth-footer">
                    {mode === "login" ? "Нет аккаунта? " : "Уже есть аккаунт? "}
                    <span
                        className="auth-link"
                        onClick={() => switchMode(mode === "login" ? "register" : "login")}
                    >
                        {mode === "login" ? "Зарегистрироваться" : "Войти"}
                    </span>
                </p>
            </div>
        </div>
    );
}
